import React from "react"
import { DatoContentBaseProps } from "../../types"
import FeaturedCardWithButton from "@components/FeaturedCardWithButton"

interface DatoCmsComponentFeaturedCardWithButtonProps
  extends DatoContentBaseProps {}

const stripHash = (value?: string) =>
  value?.startsWith("#") ? value.slice(1) : value

const formatFeaturedCard = (card: any = {}) => {
  const image = card?.image || card?.backgroundImage || card?.cardImage
  return {
    id: card?.id,
    title: card?.title || card?.heading || card?.header,
    subtitle: card?.subtitle || card?.subheading || card?.body,
    image: image?.responsiveImage,
    imageSrc: image?.url,
    imageAlt:
      image?.responsiveImage?.alt ||
      card?.title ||
      card?.heading ||
      "Featured card image",
    ctaText: card?.ctaText || card?.buttonText || "Learn More",
    ctaLink: card?.ctaLink || card?.buttonLink || card?.link || card?.url,
    titleColor: stripHash(card?.titleColor?.hex),
    subtitleColor: stripHash(card?.subtitleColor?.hex),
    buttonTextColor: stripHash(card?.buttonTextColor?.hex),
    buttonBackgroundColor: stripHash(card?.buttonBackgroundColor?.hex),
  }
}

const DatoCmsComponentFeaturedCardWithButton: React.FC<
  DatoCmsComponentFeaturedCardWithButtonProps
> = ({
  title,
  heading,
  header,
  backgroundColor,
  backgroundImage,
  ctaText,
  sectionCtaText,
  ctaLink,
  sectionCtaLink,
  ctaTextColor,
  ctaBackgroundColor,
  featuredCards,
}) => {
  return (
    <FeaturedCardWithButton
      title={title || heading || header || "Featured"}
      backgroundColor={stripHash(backgroundColor?.hex)}
      backgroundImageSrc={
        backgroundImage?.responsiveImage?.src || backgroundImage?.url
      }
      ctaText={ctaText || sectionCtaText}
      ctaLink={ctaLink || sectionCtaLink}
      ctaTextColor={stripHash(ctaTextColor?.hex)}
      ctaBackgroundColor={stripHash(ctaBackgroundColor?.hex)}
      featuredCards={(featuredCards || []).map(formatFeaturedCard)}
    />
  )
}

export default DatoCmsComponentFeaturedCardWithButton
